var ForgerockAccountType = /* @__PURE__ */ ((ForgerockAccountType2) => {
  ForgerockAccountType2["SSLA_OTT"] = "SSLA-OTT";
  ForgerockAccountType2["BR_OTT"] = "BR-OTT";
  ForgerockAccountType2["LATAM_OTT"] = "LATAM-OTT";
  ForgerockAccountType2["LATAM_DTH"] = "LATAM-DTH";
  ForgerockAccountType2["SSLA_DTH"] = "SSLA-DTH";
  ForgerockAccountType2["SKY_DTH"] = "SKY-DTH";
  ForgerockAccountType2["MSO_DTH"] = "MSO-DTH";
  return ForgerockAccountType2;
})(ForgerockAccountType || {});
const FORGEROCK_ACCOUNT_TYPES = ForgerockAccountType;
var UserType = /* @__PURE__ */ ((UserType2) => {
  UserType2["OTT_D2C"] = "OTT-D2C";
  UserType2["TVE"] = "TVE";
  UserType2["OTT_B2B2C"] = "OTT-B2B2C";
  UserType2["FREE"] = "FREE";
  return UserType2;
})(UserType || {});
const USER_TYPES = UserType;
var MSOProvider = /* @__PURE__ */ ((MSOProvider2) => {
  MSOProvider2["GRAN_HERMANO"] = "gran hermano";
  return MSOProvider2;
})(MSOProvider || {});
const MSO_PROVIDERS_TYPES = MSOProvider;
const USER_TYPES_BY_BUSINESS_UNIT = {
  ["SSLA-OTT" /* SSLA_OTT */]: "OTT-D2C" /* OTT_D2C */,
  ["BR-OTT" /* BR_OTT */]: "OTT-D2C" /* OTT_D2C */,
  ["LATAM-OTT" /* LATAM_OTT */]: "OTT-D2C" /* OTT_D2C */,
  ["LATAM-DTH" /* LATAM_DTH */]: "OTT-D2C" /* OTT_D2C */,
  ["SSLA-DTH" /* SSLA_DTH */]: "TVE" /* TVE */,
  ["SKY-DTH" /* SKY_DTH */]: "TVE" /* TVE */,
  ["MSO-DTH" /* MSO_DTH */]: "OTT-B2B2C" /* OTT_B2B2C */
};
function getUserTypeByBusinessUnit(businessUnit) {
  return USER_TYPES_BY_BUSINESS_UNIT[businessUnit] || businessUnit;
}
function getMSOProviderFormatted({ msoProvider, businessUnit }) {
  if (businessUnit === "MSO-DTH" /* MSO_DTH */) {
    return msoProvider ? `${msoProvider}-OTT`.toUpperCase() : "MISSING-OTT";
  }
  if (msoProvider?.toLowerCase() === "gran hermano" /* GRAN_HERMANO */) {
    return msoProvider;
  }
  return businessUnit;
}

export { FORGEROCK_ACCOUNT_TYPES, ForgerockAccountType, MSOProvider, MSO_PROVIDERS_TYPES, USER_TYPES, UserType, getMSOProviderFormatted, getUserTypeByBusinessUnit };
//# sourceMappingURL=user.js.map
